const textArea = document.querySelectorAll('.js-change-text')

textArea.forEach(function (elTextArea) {

  const textHolder = elTextArea.querySelector('.js-moving-text')
  const textHead = elTextArea.querySelector('.box__title')
  const textItems = elTextArea.querySelector('.box__content')
  const textEls = elTextArea.querySelectorAll('.box__entry')
  let firstEl = textEls[0]
  const lastEl = textEls[textEls.length-1]

  textEls.forEach(function (elText) {
    if (! elText.classList.contains('active-el')) {

      elText.classList.add('is-next')
    }
  })

  let clickCount = 0

  elTextArea.addEventListener('click', function (event) {

    let currEl = elTextArea.querySelector('.active-el')
    let nextEl = currEl.nextElementSibling

    clickCount++

    textHead.classList.add('is-open')
    textItems.classList.add('is-open')

    if (currEl === lastEl) {
      clickCount = 0

      const myTimeout = setTimeout(lastClick, 100)

      lastEl.classList.remove('active-el')
    } else if (clickCount > 1) {
      nextEl.classList.remove('is-next')
      nextEl.classList.add('active-el')
      currEl.classList.add('is-prev')
      currEl.classList.remove('active-el')
    }

    function lastClick() {
      textHead.classList.remove('is-open')
      textItems.classList.remove('is-open')

      textEls.forEach(function (elText) {
        elText.classList.add('is-next')
        elText.classList.remove('is-prev', 'active-el')
      })

      firstEl.classList.add('active-el')
      firstEl.classList.remove('is-next')
    }
  })

})
